export default "__VITE_ASSET__NyXQ8HMm__"